import React, { useState, useEffect, useCallback } from 'react';
import './App.css';
import Routes from "./routes";
import { langObj } from "./locale/index";
import { LangCtx, PayLoadCtx, RoleCtx, SignalerCtx, CitiesCtx, StatesCtx, DepartmentsCtx, SpecializationsCtx, BloodgroupCtx, DiagonisisCtx, DiseasesCtx, QualificationCtx } from "./lib/context";
// import { Auth } from "aws-amplify";
import Loader from "./lib/ui/loader/Loader";
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { ToastContainer } from 'react-toastify';
import ConsultSignaler from "./lib/consultSignaler";
import 'react-toastify/dist/ReactToastify.css';
import config from "./config.json";
import { useHistory } from 'react-router-dom';
import { currentsession, currentuserinfo, getCities, getStates, getDepartmentList, getSpecializationList, getQualificationList, getBloodGroupList, getDiagonisisList, getDiseasesList } from './actions/users'
import queryString from 'query-string';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#6abd45', },
    secondary: {
      main: '#2b80c4',
    }
  },

});


function App() {
  const [l, setLang] = useState(langObj[config.defaultLang]);
  const [payload, setPayload] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(false);
  const [signaler, setSignaler] = useState(null);
  const [states, setStates] = useState(null);
  const [citiesList, setCities] = useState(null);
  const [bloodgroups, setBloodgruops] = useState('');
  const [departments, setDepartments] = useState({});
  const [specializationsList, setSpecializationsList] = useState(null);
  const [qualifications, setQualifications] = useState(null);
  const [diagnoses, setDiagnoses] = useState(null);
  const [diseases, setDiseases] = useState(null);

  const history = useHistory();

  useEffect(() => {
    let lang = localStorage.getItem('lang');
    console.log("window.location.search ==== ", window.location.search);
    const query_data = queryString.parse(window.location.search);
    if (query_data && query_data.token && query_data.token !== '') {
      localStorage.setItem('deviceToken', query_data.token);
    }
    if (lang && lang !== config.defaultLang) {
      let l_data = langObj[lang] ? langObj[lang] : langObj[config.defaultLang];
      setLang(l_data);
    }
    getDropdownData()
    setLoading(true);
    console.log("currentsession===========")
    currentsession().then(res => {
      console.log("res in current session==========", res);
      const userGroups = res && res.accessToken && res.accessToken.payload ? res.accessToken.payload['groups'] : [];
      console.log("userGroups========", userGroups);
      let _role = userGroups.findIndex(group => group === 'Doctor') >= 0 ? "D" : userGroups.findIndex(group => group === 'Patient') >= 0 ? "P" : userGroups.findIndex(group => group === 'Clinic') >= 0 ? "C" : userGroups.findIndex(group => group === 'ClinicAdmin') >= 0 ? "CA" : null;
      console.log("_role in app.js---======", _role)
      setRole(_role || null);
      getPayLoad();
    }).catch(err => {
      console.log("err === ", err);
      setLoading(false);
    })
    // setRole(null);
    // Auth.currentSession().then(mySession => {
    //   const userGroups = mySession && mySession.accessToken && mySession.accessToken.payload ? mySession.accessToken.payload['cognito:groups'] : [];
    //   // console.log("userGroups ==== ", mySession.accessToken.payload);
    //   let _role = userGroups.findIndex(group => group === 'Doctor') >= 0 ? "D" : userGroups.findIndex(group => group === 'Patient') >= 0 ? "P" : userGroups.findIndex(group => group === 'Clinic') >= 0 ? "C" : userGroups.findIndex(group => group === 'ClinicAdmin') >= 0 ? "CA" : null;
    //   setRole(_role || null);
    //   getPayLoad();
    // }).catch(err => {
    //   console.log("err === ", err);
    //   setLoading(false);
    // })
  }, []);

  useEffect(() => {
    let ele = document.getElementsByTagName("body");
    if (l && l.locale === "ar") {
      ele[0].classList.remove('ltr');
      ele[0].classList.add('rtl');
    } else {
      // ele[0].classList.add('ltr');
      ele[0].classList.remove('rtl');
      ele[0].classList.add('ltr');
    }

  }, [l]);

  useEffect(() => {
    if (payload && payload.userId && role) {
      if (signaler === null) {
        const consultSignaler = new ConsultSignaler();
        consultSignaler.init(payload.userId, role);
        setSignaler(consultSignaler);
      }
    } else {
      setSignaler(null);
    }
  }, [payload, role])

  const getPayLoad = async () => {
    // const payLoad = await Auth.currentUserInfo();
    await currentuserinfo().then(res => {
      console.log("res in get currentuserinfo======", res)
      if (res && res.attributes && res.attributes.userId) {
        setPayload(res && res.attributes ? res.attributes : null);
      }
      setLoading(false);

    }).catch(err => {
      console.log("err in app.js========", err);
      // setLoading(false);
      console.log("err in current userinfo======", err);
    })
  }

  const getDropdownData = async () => {
    getStates().then(res => {
      if (res && res.data) {
        setStates([...res.data])
      }

    }).catch(err => {
      console.log("err in get states======", err);
    })

    getCities().then(res => {
      if (res && res.data) {
        setCities([...res.data])
      }
    }).catch(err => {
      console.log("err in get cities======", err);
    })

    getBloodGroupList().then(res => {
      if (res && res.data) {
        setBloodgruops([...res.data])
      }
    }).catch(err => {
      console.log("err in get bloodgroups======", err);
    })

    getDepartmentList().then(res => {
      if (res && res.data) {
        let _depat = {}
        for (let i in res.data) {
          _depat[res.data[i].value] = res.data[i];
        }
        setDepartments({ ..._depat })
      }

    }).catch(err => {
      console.log("err in get departments======", err);
    })

    getSpecializationList().then(res => {
      if (res && res.data) {
        console.log(" get specialization======", res.data);
        setSpecializationsList(res.data)
      }

    }).catch(err => {
      console.log("err in get specialization======", err);
    })

    getQualificationList().then(res => {
      if (res && res.data) {
        setQualifications([...res.data])
      }

    }).catch(err => {
      console.log("err in get qualifications ======", err);
    })

    getDiseasesList().then(res => {
      if (res && res.data) {
        setDiseases([...res.data])
      }

    }).catch(err => {
      console.log("err in get Diseases======", err);
    })

    getDiagonisisList().then(res => {
      if (res && res.data) {
        setDiagnoses([...res.data])
      }

    }).catch(err => {
      console.log("err in get specialization======", err);
    })
  }

  // console.log("pyload === ", payload);
  return (
    <MuiThemeProvider theme={theme}>
      <LangCtx.Provider value={{ l, setLang }}>
        <PayLoadCtx.Provider value={{ payload, getPayLoad, setPayload }}>
          <RoleCtx.Provider value={{ role, setRole }}>
            <SignalerCtx.Provider value={{ signaler }}>
              <StatesCtx.Provider value={{ states }}>
                <CitiesCtx.Provider value={{ citiesList }}>
                  <BloodgroupCtx.Provider value={{ bloodgroups }}>
                    <DepartmentsCtx.Provider value={{ departments }}>
                      <SpecializationsCtx.Provider value={{ specializationsList }}>
                        <QualificationCtx.Provider value={{ qualifications }}>
                          <DiseasesCtx.Provider value={{ diseases }}>
                            <DiagonisisCtx.Provider value={{ diagnoses }}>
                              <div className="App">
                                {loading ? <Loader /> : <Routes />}
                                <ToastContainer />
                              </div>
                            </DiagonisisCtx.Provider>
                          </DiseasesCtx.Provider>
                        </QualificationCtx.Provider>
                      </SpecializationsCtx.Provider>
                    </DepartmentsCtx.Provider>
                  </BloodgroupCtx.Provider>
                </CitiesCtx.Provider>
              </StatesCtx.Provider>
            </SignalerCtx.Provider>
          </RoleCtx.Provider>
        </PayLoadCtx.Provider>
      </LangCtx.Provider>
    </MuiThemeProvider>
  );
}

export default App;
